if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            // Escape inside the search panel only closes the search panel.
            if (this.searchDrawer?.open) return;
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
          }
        }
      });
      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
      }
      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
          if (this.searchDrawer?.open) {
            setTimeout(() => {
              this.searchDrawer.classList.remove('is-visible');
              this.searchDrawer.open = false;
              this.menu.classList.remove('search-active');
            }, 400);
          }
        } else {
          document.body.classList.add('overflow-hidden');
          // The <details> opens on this click; wait for that, then force a
          // reflow so the drawer starts off-canvas before it slides in.
          setTimeout(() => {
            void this.menu.offsetWidth;
            this.toggle.classList.add('active');
          });
        }
        window.dispatchEvent(new Event('resize.resize-select'));
      });

      // Sticky Header Class
      window.addEventListener('scroll', this.setStickyClass.bind(this), {
        passive: true
      });

      // Mobile Menu offset
      window.addEventListener('scroll', this.setHeaderOffset.bind(this), {
        passive: true
      });
      window.addEventListener('scroll', this.setHeaderHeight.bind(this), {
        passive: true
      });

      // Set header top position
      this.setHeaderTop();
      window.addEventListener('resize', this.setHeaderTop.bind(this), {
        passive: true
      });

      window.dispatchEvent(new Event('scroll'));

      if (document.querySelector('.announcement-bar-section')) {

        window.addEventListener('scroll', this.setAnnouncementHeight(), {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      this.initMobileAccordions();
      this.initMobileSearch();
    }
    prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
    initMobileAccordions() {
      this.accordions = this.menu.querySelectorAll('.mobile-menu__accordion');
      this.accordions.forEach((details) => {
        if (details.open) details.classList.add('is-open');
        details.querySelector(':scope > summary').addEventListener('click', (e) => {
          e.preventDefault();
          if (details.classList.contains('is-open')) {
            this.closeAccordion(details);
          } else {
            this.accordions.forEach((other) => {
              if (other !== details && other.classList.contains('is-open')) this.closeAccordion(other);
            });
            this.openAccordion(details);
          }
        });
      });
    }
    openAccordion(details) {
      const panel = details.querySelector('.mobile-menu__panel');
      details.open = true;
      details.classList.add('is-open');
      if (this.prefersReducedMotion()) return;

      details._animation?.cancel();
      details._animation = panel.animate(
        [{ height: '0px' }, { height: `${panel.scrollHeight}px` }],
        { duration: 280, easing: 'cubic-bezier(0.65, 0, 0.35, 1)' }
      );
      panel.firstElementChild?.animate(
        [{ transform: 'translateY(-32px)', opacity: 0 }, { transform: 'none', opacity: 1 }],
        { duration: 280, easing: 'cubic-bezier(0.65, 0, 0.35, 1)' }
      );
    }
    closeAccordion(details) {
      const panel = details.querySelector('.mobile-menu__panel');
      details.classList.remove('is-open');
      if (this.prefersReducedMotion()) {
        details.open = false;
        return;
      }

      details._animation?.cancel();
      details._animation = panel.animate(
        [{ height: `${panel.offsetHeight}px` }, { height: '0px' }],
        { duration: 240, easing: 'cubic-bezier(0.65, 0, 0.35, 1)' }
      );
      panel.firstElementChild?.animate(
        [{ transform: 'none', opacity: 1 }, { transform: 'translateY(-32px)', opacity: 0 }],
        { duration: 240, easing: 'cubic-bezier(0.65, 0, 0.35, 1)', fill: 'forwards' }
      );
      details._animation.onfinish = () => {
        details.open = false;
        panel.firstElementChild?.getAnimations().forEach((a) => a.cancel());
        details._animation = null;
      };
    }
    initMobileSearch() {
      this.searchDrawer = this.menu.querySelector('#search-drawer');
      if (!this.searchDrawer) return;

      const trigger = this.menu.querySelector('.search-trigger');
      const input = this.searchDrawer.querySelector('.search-drawer__input');

      trigger?.addEventListener('click', () => this.openSearch());
      trigger?.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.openSearch();
        }
      });
      this.searchDrawer.querySelector('.search-drawer__overlay').addEventListener('click', (e) => {
        e.preventDefault();
        this.closeSearch();
      });
      this.searchDrawer.querySelector('[data-search-drawer-close]').addEventListener('click', () => {
        this.closeSearch();
        trigger?.focus();
      });
      this.searchDrawer.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          e.stopPropagation();
          this.closeSearch();
          trigger?.focus();
        }
      });
      this.searchInput = input;
    }
    openSearch() {
      clearTimeout(this.searchCloseTimer);
      this.menu.scrollTop = 0;
      this.menu.classList.add('search-active');
      this.searchDrawer.open = true;
      void this.searchDrawer.offsetHeight;
      this.searchDrawer.classList.add('is-visible');
      this.searchInput?.focus({ preventScroll: true });
    }
    closeSearch() {
      if (!this.searchDrawer.open) return;
      this.searchDrawer.classList.remove('is-visible');
      this.searchCloseTimer = setTimeout(() => {
        this.searchDrawer.open = false;
        this.menu.classList.remove('search-active');
      }, this.prefersReducedMotion() ? 0 : 300);
    }
    setStickyClass() {
      // Non-home pages can keep the scroll-state header on the whole time
      // (header setting "Use scroll-state header on all pages except the homepage").
      if (this.classList.contains('header--solid')) {
        this.classList.add('is-sticky');
        return;
      }
      if (this.classList.contains('header-sticky--active')) {
        const headerOffset = this.offsetTop;
        if (window.scrollY > headerOffset) {
          this.classList.add('is-sticky');
        } else {
          this.classList.remove('is-sticky');
        }
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.querySelector('.announcement-bar-section');
      let h = a_bar.clientHeight;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    setHeaderTop() {
      const a_bar = document.querySelector('.announcement-bar-section');
      const sticky_announcement_bar = a_bar?.querySelector('.announcement-bar--sticky');
      if (a_bar && sticky_announcement_bar && this.header_section) {
        const announcement_height = a_bar.clientHeight;
        this.header_section.style.top = announcement_height + 'px';
      }
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('submenu-open');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
    recalculateAll() {
      this.setStickyClass();
      this.setAnnouncementHeight();
      this.setHeaderOffset();
      this.setHeaderHeight();
      this.setHeaderTop();
    }
  }
  customElements.define('theme-header', ThemeHeader);
}

/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();

      this.submenus = this.querySelectorAll('.thb-full-menu .menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');
    }
    connectedCallback() {
      const _this = this;

      if (this.submenus.length) {
        document.fonts.ready.then(function() {
          window.addEventListener('resize', debounce(function() {
            _this.resizeSubMenus();
          }, 100));
        });
      }

      this.parentItems = this.querySelectorAll('.thb-full-menu > .menu-item-has-children');
      if (this.parentItems.length) {
        this.initSubmenus();
      }
      this.initNestedKeyboard();
    }

    initSubmenus() {
      this.parentItems.forEach((li) => {
        const link = li.querySelector(':scope > a');
        const submenu = li.querySelector(':scope > .sub-menu');
        if (!link || !submenu) return;

        submenu.setAttribute('inert', '');

        link.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (li.classList.contains('submenu-open')) {
              this.closeSubmenu(li);
              window.location.href = link.href;
            } else {
              this.closeAllSubmenus();
              this.openSubmenu(li);
            }
          }
        });

        li.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && li.classList.contains('submenu-open')) {
            e.stopPropagation();
            this.closeSubmenu(li);
            link.focus();
          }
        });

        li.addEventListener('focusout', (e) => {
          requestAnimationFrame(() => {
            if (!li.contains(document.activeElement)) {
              this.closeSubmenu(li);
            }
          });
        });

        li.addEventListener('mouseenter', () => {
          submenu.removeAttribute('inert');
        });

        li.addEventListener('mouseleave', () => {
          if (!li.classList.contains('submenu-open')) {
            submenu.setAttribute('inert', '');
          }
        });
      });
    }

    initNestedKeyboard() {
      this.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Escape') return;
        const link = e.target.closest('.sub-menu .menu-item-has-children > a');
        if (!link) return;
        const li = link.parentElement;
        const submenu = li.querySelector(':scope > .sub-menu');
        if (!submenu) return;

        if (e.key === 'Escape') {
          if (li.classList.contains('submenu-open')) {
            e.stopPropagation();
            li.classList.remove('submenu-open');
            link.setAttribute('aria-expanded', 'false');
            submenu.setAttribute('inert', '');
            link.focus();
          }
          return;
        }

        e.preventDefault();
        if (li.classList.contains('submenu-open')) {
          li.classList.remove('submenu-open');
          link.setAttribute('aria-expanded', 'false');
          submenu.setAttribute('inert', '');
          window.location.href = link.href;
        } else {
          const siblings = li.parentElement.querySelectorAll(':scope > .menu-item-has-children');
          siblings.forEach((sib) => {
            if (sib !== li) {
              sib.classList.remove('submenu-open');
              const sibLink = sib.querySelector(':scope > a');
              const sibSub = sib.querySelector(':scope > .sub-menu');
              if (sibLink) sibLink.setAttribute('aria-expanded', 'false');
              if (sibSub) sibSub.setAttribute('inert', '');
            }
          });
          li.classList.add('submenu-open');
          link.setAttribute('aria-expanded', 'true');
          submenu.removeAttribute('inert');
        }
      });
    }

    openSubmenu(li) {
      const link = li.querySelector(':scope > a');
      const submenu = li.querySelector(':scope > .sub-menu');
      li.classList.add('submenu-open');
      if (link) link.setAttribute('aria-expanded', 'true');
      if (submenu) submenu.removeAttribute('inert');
    }

    closeSubmenu(li) {
      const link = li.querySelector(':scope > a');
      const submenu = li.querySelector(':scope > .sub-menu');
      li.classList.remove('submenu-open');
      if (link) link.setAttribute('aria-expanded', 'false');
      if (submenu) submenu.setAttribute('inert', '');
    }

    closeAllSubmenus() {
      this.parentItems.forEach((li) => this.closeSubmenu(li));
    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.offsetWidth,
            total = w + l;

          if (total > window.innerWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}